import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=6eb0787f&scoped=true&"
import script from "./Branches.vue?vue&type=script&lang=ts&"
export * from "./Branches.vue?vue&type=script&lang=ts&"
import style0 from "./Branches.vue?vue&type=style&index=0&id=6eb0787f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0787f",
  null
  
)

export default component.exports